export default {
  nome: {
    value: '',
    required: true,
    state: null
  },
  botId: {
    value: '',
    required: true,
    state: null
  },
  dataCriacao: {
    value: '',
    required: true,
    state: null
  }
}



// WEBPACK FOOTER //
// ./src/views/private/configurations/parametros_atendimento/registroBot/components/add/registroBotadd-form.js